import PersonalSearchList from './PersonalSearchList';

export default PersonalSearchList
